import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckoutLicensesComponent} from './checkout-licenses.component';
import {I18nModule} from '@spartacus/core';
import {MessageModule, ModalModule} from 'ng-design-system';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';
import {CheckoutSupportWidgetModule} from '../checkout-support-widget/checkout-support-widget.module';
import {OrderItemModule} from '../order-item/order-item.module';
import {FooterModule} from '@app/layout/footer/footer.module';

@NgModule({
  declarations: [
    CheckoutLicensesComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    MessageModule,
    ModalModule,
    CartEditModule,
    CheckoutSupportWidgetModule,
    OrderItemModule,
    FooterModule
  ],
  exports: [
    CheckoutLicensesComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class CheckoutLicensesModule {
}
